<template>
  <div class="listOne clearfix" v-show="newList.length > 0">
    <div v-for="(item, index) in newList" :key="index" class="box-list" @click="shoDetial(item)">
      <div class="box-list-img">
        <img :src="item.title_img_path" />
      </div>
      <div class="box-list-font">
        <div class="title over-one">{{ item.article_title }}</div>
      </div>
    </div>
    <!-- <div class="page">
             <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="pageSize"
                layout="prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div> -->
  </div>
</template>
<script>
export default {
  props: {
    columnId: {
      type: String,
      default: '',

    }
  },
  data() {
    return {
      newList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      orderColunmList:['755827561772728320','753630972786360320','753631520449216512','753631613814423552','753631718109986816','753631808367214592','753631899777875968',
                '753631254408708096','753632041650208768','753632131752247296','753632220889595904','753632304628875264','753632390800850944','753632471352459264','753631328652083200',
                '753632566345056256','753632645822922752','753632722394136576','753632799682576384','753632873842065408','753631393118535680','753632953823248384',
                '753633035897389056','753633115660468224']
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      let self = this
      this.newList = []
      this.$common.noLoginCallUrl('/api/cp-cms/site/info/getInfoPage', {
        column_id: self.columnId,
        // pageNo: self.currentPage,
        // pageCount: self.pageSize,
        orderNumOrPublishTime:self.orderColunmList.includes(self.columnId)?'order_num':'publish_time'
      },
        function (res) {
          if (res.code == '000000') {
            self.newList = res.data.data || []
            self.total = res.data.count
          } else {
            self.$message.warning(res.msg)
          }
        })
    },
    handleSizeChange() {

    },
    handleCurrentChange(item) {
      this.currentPage = item
      this.getList()
    },
    shoDetial(item) {
      this.$emit('detail', item)
    }
  },
  watch: { // 监听，当路由发生变化的时候执行

  }
};
</script>

<style lang="less" scoped>
.listOne {

  .box-list {
    float: left;
    width: 20%;
    margin: 20px auto;
    height: 300px;
    box-sizing: border-box;
    padding: 20px;
    cursor: pointer;
    // border: dashed 1px #dedede;
    text-align: center;

    .box-list-img {
      margin: 0 auto;
      width: 150px;
      height: 200px;

      img {
        width: 150px;
        height: 200px;
      }
    }

    .box-list-font {
      margin-top: 20px;

      .title {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 20px;
      }

      .info {
        font-size: 14px;
        color: #666666;
      }

      .time {
        font-size: 14px;
        margin-top: 20px;
      }
    }
  }

  .page {
    text-align: center;
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 1025px) {
  .listOne .box-list {
    float: left;
    width: 50%;
    height: auto;
    margin: 10px auto;
    padding: 10px 0;
  }

  .listOne .box-list .box-list-img {
    margin: 0 auto;
    width: 90%;
    height: 25vh;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .listOne .box-list .box-list-font .title {
    margin: 0;
  }
}
</style>